import themeColors from 'styles/theme/colors.module.scss';

export const DATES_AT_A_GLANCE_TIMELINE_SERIES = [
  {
    dataKey: 'completedMilestones',
    fill: themeColors.turquoise,
    name: 'Completed',
  },
  {
    dataKey: 'overdueMilestones',
    fill: themeColors.danger,
    name: 'Overdue',
  },
  {
    dataKey: 'upcomingMilestones',
    fill: themeColors.yellow,
    name: 'Upcoming',
  },
  {
    dataKey: 'scheduledMilestones',
    fill: themeColors.neutralStatus,
    name: 'Scheduled',
  },
] as const;

export type DatesAtAGlanceTimelineDataKey =
  (typeof DATES_AT_A_GLANCE_TIMELINE_SERIES)[number]['dataKey'];

export type DatesAtAGlanceMilestoneStatus =
  | 'completed'
  | 'overdue'
  | 'upcoming'
  | 'scheduled';

export const DATES_AT_A_GLANCE_MILESTONE_STATUS_LABELS: Record<
  DatesAtAGlanceMilestoneStatus,
  string
> = {
  completed: 'Completed',
  overdue: 'Overdue',
  scheduled: 'Scheduled',
  upcoming: 'Upcoming',
};
